import * as React from "react";
const SvgFiRrOrnament = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M16 4.836V4.5c0-.827-.673-1.5-1.5-1.5h-.771a2 2 0 1 0-3.464 0h-.766c-.827 0-1.5.673-1.5 1.5v.336c-3.529 1.546-6 5.072-6 9.164 0 5.514 4.486 10 10 10s10-4.486 10-10c0-4.093-2.471-7.618-6-9.164zM12 6c4.173 0 7.609 3.212 7.968 7.293l-1.519-1.519c-1.029-1.029-2.704-1.03-3.692-.039l-2.325 2.078a.63.63 0 0 1-.445.187c-.19.006-.341-.065-.504-.23l-2.188-1.979a2.63 2.63 0 0 0-1.866-.787h-.015c-.702 0-1.361.272-1.859.767l-1.522 1.511C4.397 9.206 7.831 6 12 6m0 16c-3.755 0-6.913-2.601-7.77-6.095l2.734-2.715a.64.64 0 0 1 .451-.186h.003c.171 0 .332.069.493.23l2.188 1.979c.501.509 1.18.768 1.913.787a2.58 2.58 0 0 0 1.793-.734l2.325-2.079a.655.655 0 0 1 .905 0l2.732 2.732C18.905 19.406 15.75 22 12 22"
    />
  </svg>
);
export default SvgFiRrOrnament;
